import { actionCreator } from 'utils';
import * as BoxTypes from '../types/boxTypes';

// L O A D   B O X E S
export function loadBoxes() {
    return {
        type: BoxTypes.LOAD_BOXES,
    };
}

export function loadBoxesRes(data) {
    return {
        type: actionCreator(BoxTypes.LOAD_BOXES, 'res'),
        data,
    };
}

export function loadBoxesErr() {
    return {
        type: actionCreator(BoxTypes.LOAD_BOXES, 'err'),
    };
}
// L O A D   B O X E S


// S E T   B O X
export function setBoxPagination(key, pagination) {
    return {
        type: BoxTypes.SET_BOX_PAGINATION,
        key,
        pagination,
    };
}

export function setBoxFilters(key, value) {
    return {
        type: BoxTypes.SET_BOX_FILTERS,
        key,
        value,
    };
}
// S E T   B O X


// A D D   B O X
export function addBox(data) {
    return {
        type: BoxTypes.ADD_BOX,
        data,
    };
}

export function addBoxRes() {
    return {
        type: actionCreator(BoxTypes.ADD_BOX, 'res'),
    };
}

export function addBoxErr(error) {
    return {
        type: actionCreator(BoxTypes.ADD_BOX, 'err'),
        error,
    };
}
// A D D   B O X

// E D I T   B O X
export function editBox(data) {
    return {
        type: BoxTypes.EDIT_BOX,
        data,
    };
}

export function editBoxRes() {
    return {
        type: actionCreator(BoxTypes.EDIT_BOX, 'res'),
    };
}

export function editBoxErr(error) {
    return {
        type: actionCreator(BoxTypes.EDIT_BOX, 'err'),
        error,
    };
}
// E D I T   B O X

// L O A D   E D I T A B L E   B O X
export function loadEditableBox(id) {
    return {
        type: BoxTypes.LOAD_EDITABLE_BOX,
        id,
    };
}

export function loadEditableBoxRes(data) {
    return {
        type: actionCreator(BoxTypes.LOAD_EDITABLE_BOX, 'res'),
        data,
    };
}

export function loadEditableBoxErr() {
    return {
        type: actionCreator(BoxTypes.LOAD_EDITABLE_BOX, 'err'),
    };
}

export function setEmptyEditableBox() {
    return {
        type: BoxTypes.SET_EMPTY_EDITABLE_BOX,
    };
}
// L O A D   E D I T A B L E   B O X
